import { ECampaign } from '@/shared/enum/campaign.enum'

export const isShortLink = (campaign: string): boolean => {
  const substringShortlink = campaign.substring(0, 2)?.toUpperCase() === ECampaign.PACKAGE_PREFIX
  return substringShortlink
}
